export const ONBOARDING_CHAT_DONE_KEY = 'ONBOARDING_CHAT_DONE_KEY';
export const ON_BOARDING_JOURNEY_STATE = 'ONBOARDING_JOURNEY';
